import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import styled from 'styled-components';

const ConnectButtonWrapper = styled.div`
  .connect-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    padding: 8px 16px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    font-weight: 500;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
`;

const StyledButton = styled.button`
  background: transparent;
  position: relative;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  border: 1.5px solid rgb(252, 252, 252);
  border-radius: 25px;
  outline: none;
  overflow: hidden;
  color: rgb(252, 252, 252);
  transition: color 0.3s 0.1s, border 0.3s, background 0.3s;
  text-align: center;
  box-shadow: 0 2px 12px rgb(252, 252, 252)22;
  height: 38px;
  justify-content: center;

  span {
    margin: 10px;
    font-family: 'Orbitron', 'Montserrat', 'Arial', sans-serif;
    letter-spacing: 1.5px;
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    content: "";
    border-radius: 50%;
    display: block;
    width: 20em;
    height: 20em;
    left: -5em;
    text-align: center;
    transition: box-shadow 0.5s ease-out;
    z-index: -1;
  }

  &:hover {
    color: #fff;
    border: 1.5px solid #ffb300;
    background: linear-gradient(90deg, #a335ee 0%, #ffb300 100%);
    box-shadow: 0 0 24px #a335ee55;
  }

  &:hover::before {
    box-shadow: inset 0 0 0 10em #a335ee;
  }
`;

const BSCWalletButton: React.FC = () => {



  return (
    <ConnectButtonWrapper>
      <ConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          mounted,
        }) => {
          const ready = mounted;
          const connected = ready && account && chain;

          return (
            <div
              {...(!ready && {
                'aria-hidden': true,
                style: {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                if (!connected) {
                  return (
                    <StyledButton onClick={openConnectModal}>
                      <span>连接钱包</span>
                    </StyledButton>
                  );
                }

                if (chain.unsupported) {
                  return (
                    <StyledButton onClick={openChainModal}>
                      <span>错误网络</span>
                    </StyledButton>
                  );
                }

                return (
                  <div className="connect-button" onClick={openAccountModal}>
                    {account.displayName}
                  </div>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
    </ConnectButtonWrapper>
  );
};

export default BSCWalletButton; 